import { createQueryKeys } from "@lukemorales/query-key-factory"

import API from "../../index"
import { GetProductsRequestParams } from "./product.types"

export const PRODUCT_DTO_ENUMS = {
  TYPE: {
    PRODUCT: "PRODUCT",
    PRODUCT_MASTER: "PRODUCT_MASTER",
  },
} as const

export const GET_PRODUCTS_DTO_ENUMS = {
  ORDER_BY: {
    ID_ASC: "id_asc",
  },
} as const

export const productQueryKeys = createQueryKeys("product", {
  getProducts: (params: GetProductsRequestParams) => ({
    queryKey: [{ params }],
    queryFn: () => API.Product.getProducts(params),
  }),
})
